// extracted by mini-css-extract-plugin
export default {"card":"styles_card__f3iql","header":"styles_header__-BvXr","close":"styles_close__UjwYX","body":"styles_body__iUnLH"};